import { campaignEditorInitialState } from './campaignEditorInitialState';
import { CampaignEditorAction, CampaignEditorState } from './CampaignEditorState';
import { DisplayWebContentReducer } from '../tabs/CampaignWorkflowTab/components/Workflows/DisplayWebContent/state/DisplayWebContentReducer';
import { TriggerReducer } from '../tabs/CampaignWorkflowTab/components/Workflows/Trigger/state/TriggerReducer';
import { SendEmailReducer } from '../tabs/CampaignWorkflowTab/components/Workflows/SendEmail/state/SendEmailReducer';
import { CampaignSettingsReducer } from '../tabs/CampaignWorkflowTab/state/CampaignSettings/CampaignSettingsReducer';
import { BranchesReducer } from '../tabs/CampaignWorkflowTab/state/Branches/BranchesReducer';
import { DrawerReducer } from '../tabs/CampaignWorkflowTab/state/Drawer/DrawerReducer';
import { SplitTestsReducer } from '../tabs/CampaignWorkflowTab/state/SplitTests/SplitTestsReducer';

export const CampaignEditorReducer = (
  state: CampaignEditorState,
  action: CampaignEditorAction,
): CampaignEditorState => {
  if (action.type === 'CLEAR_SELECTED_CAMPAIGN') {
    return campaignEditorInitialState;
  }

  if (action.type === 'SET_CAMPAIGN_EDITOR_INITIAL_STATE') {
    return action.payload.initialState;
  }

  if (action.type === 'MOVE_AND_REVERT_CHANGES') {
    return {
      ...state,
      edit: undefined,
    };
  }

  if (action.type === 'SAVE_CAMPAIGN') {
    return {
      ...state,
      ...state.edit,
      edit: undefined,
    };
  }

  if (action.type === 'OPEN' || action.type === 'CLOSE') {
    return {
      ...state,
      ...DrawerReducer(state, action),
    };
  }

  if (action.type === 'RESET_TO_TRIGGER') {
    return {
      ...state,
      edit: {
        ...state.edit,
        messages: {},
        splitTests: {},
        branches: {},
      },
    };
  }

  const newState = reducer({ ...state, ...state.edit }, action);

  return {
    ...state,
    edit: newState,
  };
};

const reducer = (state: CampaignEditorState, action: CampaignEditorAction): CampaignEditorState => {
  switch (action.type) {
    case 'SET_SELECTED_TRIGGER_TYPE':
    case 'REMOVE_SELECTED_TRIGGER_TYPE':
    case 'SET_INACTIVITY_DURATION_TIMER':
    case 'SET_CAMPAIGN_ALL_EXIT_INTENTS':
    case 'SET_CAMPAIGN_EXIT_INTENT':
    case 'CLEAR_CAMPAIGN_EXIT_INTENT':
    case 'SET_ON_CLICK_CONFIG':
    case 'CLEAR_TRIGGER_SEGMENTATION':
    case 'SEGMENTATION_CHOSEN':
    case 'SAVE_TRIGGER_SEGMENTATION':
    case 'SET_FREQUENCY': {
      const trigger = state.trigger;

      const newState = TriggerReducer(trigger, action);

      return {
        ...state,
        trigger: {
          ...trigger,
          ...newState,
        },
      };
    }
    case 'ADD_DISPLAY_WEB_CONTENT':
    case 'SET_TEMPLATE':
    case 'UPDATE_DISPLAY_WEB_CONTENT_NAME':
    case 'REMOVE_DISPLAY_WEBSITE_CONTENT':
    case 'CLEAR_DISPLAY_SEGMENTATION':
    case 'DISPLAY_SEGMENTATION_CHOSEN':
    case 'SAVE_DISPLAY_SEGMENTATION':
    case 'SET_CONTROL_GROUP':
    case 'SET_EMBEDDED_SELECTOR':
    case 'SET_EMBEDDED_POSITION':
    case 'UPDATE_MESSAGE_TRIGGERS':
    case 'SET_SEGMENT_START_DATE':
    case 'SET_SEGMENT_START_TIME':
    case 'SET_SEGMENT_END_DATE':
    case 'SET_SEGMENT_END_TIME':
    case 'REMOVE_SEGMENT_DATETIMES': {
      const messages = DisplayWebContentReducer(state.messages, action);

      return {
        ...state,
        messages,
      };
    }
    case 'REMOVE_SEND_EMAIL_MESSAGE':
    case 'SET_SEND_EMAIL_TEMPLATE':
    case 'SET_SELECTED_SUBJECT_LINE':
    case 'UPDATE_SEND_EMAIL_NAME':
    case 'ADD_SEND_EMAIL':
    case 'LINK_SEND_EMAIL_TO_DISPLAY_WEB_CONTENT': {
      const messages = SendEmailReducer(state.messages, action);

      return {
        ...state,
        messages,
      };
    }
    case 'SET_CAMPAIGN_STATUS':
    case 'SET_CAMPAIGN_NAME':
    case 'SET_CAMPAIGN_ALLOWLIST':
    case 'SET_EMAIL_ALLOW_LIST':
    case 'SET_LOOKBACK_PERIOD':
    case 'SET_CAMPAIGN_START_DATE':
    case 'SET_CAMPAIGN_START_TIME':
    case 'SET_CAMPAIGN_END_DATE':
    case 'SET_CAMPAIGN_END_TIME': {
      const newState = CampaignSettingsReducer(state, action);
      return {
        ...state,
        ...newState,
      };
    }
    case 'INIT_BRANCHES':
    case 'ADD_BRANCHES':
    case 'REMOVE_BRANCHES':
    case 'UPDATE_BRANCH':
    case 'ORGANISE_BRANCHES': {
      const branches = BranchesReducer(state, action);

      return {
        ...state,
        ...branches,
      };
    }

    case 'ENABLE_SPLIT_TEST':
    case 'DISABLE_SPLIT_TEST':
    case 'REMOVE_VARIANT':
    case 'SET_DEFAULT_VARIANT':
    case 'UPDATE_VARIANT_WEIGHT':
    case 'SET_SPLIT_TEST_CONTROL_GROUP':
    case 'SET_START_DATE':
    case 'SET_START_TIME':
    case 'SET_END_DATE':
    case 'SET_END_TIME':
    case 'UPDATE_SPLIT_TEST_NAME':
    case 'UPDATE_SPLIT_TEST_ID': {
      const splitTests = SplitTestsReducer(state.splitTests, action);

      return { ...state, splitTests };
    }
    default:
      return state;
  }
};
